import { apis } from '@doltech/core/lib/api/api.config';
import { apiUrls } from '@doltech/core/lib/api/api.urls';

export const getSpeechToTextToken = async () => {
  const { data } = await apis.cognitiveService.post<any>(
    apiUrls.cognitiveService.SPEECH_TO_TEXT_TOKEN
  );
  return data;
};
